var _ = require('underscore');
var TorsoView = require('backbone-torso/modules/View');
var accountEstimateItemTemplate = require('./estimateItemTemplate.hbs');
var applicationUtils = require('./../applicationUtils');
var AppointmentTypeDataBehavior = require('./../appointment-type/AppointmentTypeDataBehavior');
var SecureMessageDataBehavior = require('./../secure-message/SecureMessageDataBehavior');
var financialFeatureService = require('./../financial/financialFeatureService');

/**
 * @class EstimateItemView
 * @constructor
 * @param options {Object} options for this view.
 *   @param options.context {Object} The child context from the list view.
 *     @param options.context.tableState {Torso.Cell} the shared state for this table.
 * @extends Torso.View
 */
module.exports = TorsoView.extend({
  tagName: 'li',
  className: 'brec-list__item brec-list__item--border brec-list__item--multi-linked',
  template: accountEstimateItemTemplate,

  behaviors: {
    appointmentSecureMessages: {
      behavior: SecureMessageDataBehavior,
      renderOnFetch: true,
      ids: function(cache) {
        var accountNumber = this.view.model.get('accountNumber');
        if (!accountNumber) {
          return { skipObjectRetrieval: true };
        }

        var patientVecnaId = this.view._tableState.get('patientVecnaId');
        var criteria = {
          isPatient: true,
          vecnaIds: [patientVecnaId],
          appointmentCriteria: {
            externalAppointmentCriteria: {
              accountNumbers: [accountNumber]
            }
          }
        };
        return cache.fetchIdsByCriteria(criteria);
      }
    },
    appointmentTypes: {
      behavior: AppointmentTypeDataBehavior,
      renderOnFetch: true,
      ids: { property: 'behaviors.appointmentSecureMessages.data:appointmentDTO.externalAppointment.type'}
    }
  },

  events: {
    'click [data-view-estimate-details]': '_showEstimatedCostDetails'
  },

  /**
   * @method initialize
   * @param options {Object} options for this view.
   *   @param options.context {Object} The child context from the list view.
   *     @param options.context.tableState {Torso.Cell} the shared state for this table.
   * @override
   */
  initialize: function(options) {
    _.bindAll(this,'render');
    this._tableState = options.context.tableState;
    financialFeatureService.fetchPayAbility(this._patientVecnaId)
      .then(this.render);

    this.listenTo(this.model, 'change:hasUnapprovedInsuranceUpdates', this._triggerPendingCheck);
    this.listenTo(this.model, 'change', this.render);
  },

  /**
   * @method prepare
   * @override
   */
  prepare: function() {
    var context = TorsoView.prototype.prepare.apply(this);

    var doneLoadingAppointments = !this.getBehavior('appointmentSecureMessages').isLoading();
    var doneLoading = doneLoadingAppointments;
    var hasUnapprovedInsuranceUpdates = this.hasUnapprovedInsuranceUpdates();
    var viewDetails = doneLoading && !hasUnapprovedInsuranceUpdates;
    this.set('viewDetails', viewDetails);
    context.doneLoading = doneLoading;
    context.viewDetails = viewDetails;
    context.currentApplication = applicationUtils.currentApplication;
    context.patientVecnaId = this._tableState.get('patientVecnaId');
    context.estimateIsPaid = this.model.insuranceEstimateIsPaid();
    context.paymentAllowed = this._checkPaymentAllowed();

    return context;
  },

  /**
   * @method hasUnapprovedInsuranceUpdates
   * @return {Boolean} true if the are outstanding updates on the insurance under this account that need to be approved, false otherwise.
   */
  hasUnapprovedInsuranceUpdates: function() {
    return this.model.get('hasUnapprovedInsuranceUpdates');
  },

  /**
   * @method _showEstimatedCostDetails
   * @private
   */
  _showEstimatedCostDetails: function(event) {
    if (event) {
      event.preventDefault();
      if (this.get('viewDetails')) {
        var url = $(event.currentTarget).attr('href');
        window.location.assign(url);
      }
    }
  },

  /**
   * @method _triggerPendingCheck
   * @private
   */
  _triggerPendingCheck: function() {
    this.model.trigger('checkPendingEstimates');
  },

  /**
   * Determines when payment is allowed for patient and/or admin
   * @method _checkPaymentAllowed
   * @returns {boolean|*|Object|Boolean}
   * @private
   */
  _checkPaymentAllowed: function() {
    var patientVecnaId = this._tableState.get('patientVecnaId');
    var hasAccountNumber = !_.isEmpty(this.model.get('accountNumber'));
    var patientPaymentAllowed = hasAccountNumber && financialFeatureService.patientPaymentAllowed(patientVecnaId);
    var adminPaymentAllowed = financialFeatureService.adminPaymentAllowed();
    return patientPaymentAllowed || adminPaymentAllowed;
  }
});
